const getNestedProperty = (object, ...path) =>
  path.reduce((currentObj, nextProperty) => {
    if (currentObj === null || typeof currentObj === 'undefined') {
      return undefined
    }
    return currentObj[nextProperty]
  }, object)

export default getNestedProperty
